const BASE = '/mopsc-app-station/api/ecpt';
const ACCESS_REQUEST_BASE = '/mopsc-app-station/api/access-request';

export const ECPT_ENDPOINTS = {
  // Health
  HEALTH_CHECK: `${BASE}/health-check`,

  // Auth
  AUTH_LOGIN: `${BASE}/auth/login`,

  // Settings — Views
  SETTINGS_VIEWS: `${BASE}/settings/views`,
  SETTINGS_VIEW: (id: string) => `${BASE}/settings/views/${id}`,

  // Settings — Feedback Recipients
  FEEDBACK_RECIPIENTS: `${BASE}/settings/feedback-recipients`,
  FEEDBACK_USER_RECIPIENTS: `${BASE}/settings/feedback-recipients/user-recipients`,
  FEEDBACK_USER_RECIPIENT: (id: string) =>
    `${BASE}/settings/feedback-recipients/user-recipients/${id}`,
  FEEDBACK_EMAIL_GROUPS: `${BASE}/settings/feedback-recipients/email-groups`,
  FEEDBACK_EMAIL_GROUP: (id: string) =>
    `${BASE}/settings/feedback-recipients/email-groups/${id}`,

  // Settings — Share
  SETTINGS_SHARE_USERS: `${BASE}/settings/share/users`,
  SETTINGS_VIEWS_SHARE: `${BASE}/settings/views/share`,

  // Operation Overview
  OPERATION_OVERVIEW_VIEWS: `${BASE}/operation-overview/views`,
  OPERATION_OVERVIEW_DATA: `${BASE}/operation-overview/data`,
  OPERATION_OVERVIEW_DATA_V2: `${BASE}/operation-overview/data/v2`,
  OPERATION_OVERVIEW_GET_CASE: `${BASE}/operation-overview/get-case`,
  OPERATION_OVERVIEW_PEM_STATUS: `${BASE}/operation-overview/pem-status`,
  OPERATION_OVERVIEW_PEM_COMPLETION_STATUS: `${BASE}/operation-overview/pem-completion-status`,
  OPERATION_OVERVIEW_PIN: `${BASE}/operation-overview/pin`,
  OPERATION_OVERVIEW_SEARCH_PEM: `${BASE}/operation-overview/search-pem`,

  // Get Case
  GET_CASE_VIEWS: `${BASE}/get-case/views`,
  GET_CASE_DATA: `${BASE}/get-case/data`,
  GET_CASE_DATA_V2: `${BASE}/get-case/data/v2`,
  GET_CASE_PEM_STATUS: `${BASE}/get-case/pem-status`,
  GET_CASE_PEM_COMPLETION_STATUS: `${BASE}/get-case/pem-completion-status`,

  // Settings — Custom Fields
  SETTINGS_CUSTOM_FIELDS: `${BASE}/settings/custom-fields`,
  SETTINGS_CUSTOM_FIELD: (id: number) => `${BASE}/settings/custom-fields/${id}`,

  // Settings — Checklist Tasks
  SETTINGS_CHECKLIST_TASKS: `${BASE}/settings/checklist-tasks`,
  SETTINGS_CHECKLIST_TASK: (id: string) => `${BASE}/settings/checklist-tasks/${id}`,

  SETTINGS_CHECKLISTS: `${BASE}/settings/checklists`,
  SETTINGS_CHECKLIST: (id: string) => `${BASE}/settings/checklists/${encodeURIComponent(id)}`,
  FEEDBACK_CHECKLISTS: `${BASE}/feedback/checklists`,
  FEEDBACK_CHECKLIST: (id: string) => `${BASE}/feedback/checklists/${encodeURIComponent(id)}`,
  FEEDBACK_CHECKLIST_ANSWER: (id: string, questionId: string) =>
    `${BASE}/feedback/checklists/${encodeURIComponent(id)}/questions/${encodeURIComponent(questionId)}/answer`,

  // Operation Overview — Custom Field Value
  OPERATION_OVERVIEW_CUSTOM_FIELD_VALUE: `${BASE}/operation-overview/custom-field-value`,
  GET_CASE_CUSTOM_FIELD_VALUE: `${BASE}/get-case/custom-field-value`,

  // Feedback
  FEEDBACK: `${BASE}/feedback`,
  FEEDBACK_REPLY: (conversationId: string) => `${BASE}/feedback/${conversationId}/reply`,
  FEEDBACK_STATUS: (conversationId: string) => `${BASE}/feedback/${conversationId}/status`,
  FEEDBACK_SUMMARY: (conversationId: string) => `${BASE}/feedback/${conversationId}/summary`,

  // Export
  EXPORT_DATA: `${BASE}/export/data`,

  // Part Lookup
  PART_LOOKUP: (partNumber: string) => `${BASE}/part-lookup/${encodeURIComponent(partNumber)}`,
  PART_LOOKUP_SEARCH: `${BASE}/part-lookup`,

  // Access Request
  ACCESS_REQUEST_APPS: `${ACCESS_REQUEST_BASE}/apps`,
  ACCESS_REQUEST_SUBMIT: `${ACCESS_REQUEST_BASE}/submit`,
  ACCESS_REQUEST_STATUS: (requestId: string) => `${ACCESS_REQUEST_BASE}/status/${requestId}`,
} as const;

export const CHATBOT_ENDPOINTS = {
  HEALTH: '/api/health',
  READY: '/api/ready',
  CHAT: '/api/chat',
  WS_CHAT: '/ws/chat',
} as const;

